import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  Box,
} from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const KurumModal = ({ open, onClose, onSuccess, initialData }) => {
  const [form, setForm] = useState({
    kurum_adi: "",
    sirket_unvani: "",
    vergi_no: "",
    tc: "",
    adres: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* 🔹 EDIT MODE: formu doldur */
  useEffect(() => {
    if (initialData) {
      setForm({
        kurum_adi: initialData.kurum_adi || "",
        sirket_unvani: initialData.sirket_unvani || "",
        vergi_no: initialData.vergi_no || "",
        tc: initialData.tc || "",
        adres: initialData.adres || "",
      });
    } else {
      setForm({
        kurum_adi: "",
        sirket_unvani: "",
        vergi_no: "",
        tc: "",
        adres: "",
      });
    }
  }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    const isEdit = Boolean(initialData?.id);
    const url = isEdit
      ? `${API_URL}/kurumlar/${initialData.id}`
      : `${API_URL}/kurumlar`;

    const method = isEdit ? "PUT" : "POST";

    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.detail || "İşlem başarısız");
      }

      const result = await res.json();

      onSuccess?.(result);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { maxHeight: "85vh" },
      }}
    >
      <DialogTitle>
        {initialData ? "Kurum Düzenle" : "Kurum Ekle"}
      </DialogTitle>

      <DialogContent dividers sx={{ overflowY: "auto" }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            size="small"
            label="Kurum Adı"
            name="kurum_adi"
            value={form.kurum_adi}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            size="small"
            label="Şirket Ünvanı"
            name="sirket_unvani"
            value={form.sirket_unvani}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            size="small"
            label="Vergi No"
            name="vergi_no"
            value={form.vergi_no}
            onChange={handleChange}
            fullWidth
            required
          />

          <TextField
            size="small"
            label="Yetkili TC"
            name="tc"
            value={form.tc}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                tc: e.target.value.replace(/\D/g, "").slice(0, 11),
              }))
            }
            fullWidth
            required
          />

          <TextField
            size="small"
            label="Adres"
            name="adres"
            value={form.adres}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>İptal</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Kaydediliyor..." : "Kaydet"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KurumModal;
